export default __webpack_public_path__ + "static/media/portable-speaker-1.a8637a0b.png";